
const Reset = `
  margin:0;
  padding:0;
  border:0;
  outline:0;
  font-size:100%;
  vertical-align:baseline;
  background:transparent;
  text-decoration: none;
`;

module.exports = {
  Reset: Reset
};
